import {useDateTime} from '../../../fields/dateTime/useDateTime'
import {AvailableTimeSlotsResult, UseAvailableTimeSlotsParams} from '../../../slotManagement'

import {useOrderIntakeSlotAvailability} from './useOrderIntakeSlotAvailability'

export const useOrderIntakeAvailableTimeSlots = (
  params: UseAvailableTimeSlotsParams
): AvailableTimeSlotsResult => {
  const {dateTime} = useDateTime()

  return useOrderIntakeSlotAvailability({...params, selectedDateTime: dateTime?.[0]})
}
